<template>
  <div class="um-page">
    <header v-if="isApp">
      <div class="page-header-left" @click="back"><i class="iconfont icon-zuoye"></i></div>
      <slot name="title"><h4>{{title}}</h4></slot>
      <div class="page-header-right">
        <slot name="right"></slot>
      </div>
    </header>
    <main>
      <slot>
      </slot>
    </main>
    <footer>
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
import { exitApp } from "@/plugins/cordova"
import { device } from "@/utils/device.js"
export default {
  name: 'um-page',
  props: {
    title: String
  },
  data () {
    return {

    }
  },
  computed: {
    isApp () {
      return device.isRunningStandalone
    }
  },
  mounted () {
    console.log(this)
  },
  methods:{
    back () {
      if (this.$listeners.back) {
        return this.$listeners.back()
      }
      if (this.$route.meta.isNoHistory) {
        exitApp()
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
